import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import QRCode from 'react-qr-code';
export function GiroCode({ value }) {
    return (_jsxs("div", Object.assign({ className: "flex flex-col items-center py-4 gap-1" }, { children: [_jsx(QRCode, { className: "mx-auto", value: value, fgColor: '#072440' }), _jsx("p", Object.assign({ className: "text-dfxBlue-800 font-semibold text-base" }, { children: "GiroCode" }))] })));
}
